import React from 'react'

export default function ConfidentialityandNonDiscrimination() {
    return (
        <div>
            <br />
                         <br />
                         <p className='mainFont' style={{fontSize: '1em', marginTop: '0'}}><b>Confidentiality</b></p>
                    <p className='mainFont' style={{fontSize: '1em', marginTop: '0'}}>
                        CARE Hawaii is committed to
                        maintaining the privacy and
                        understands the importance of
                        safeguarding the client’s personal
                        health information. We are required
                        by Federal Law to maintain the
                        privacy of health information that
                        identifies you or that could be used
                        to identify you. Information
                        regarding your health care is
                        protected by the Health Insurance
                        Portability and Accountability Act of
                        1996 (HIPAA). We will not use or
                        disclose personal health information
                        without consent, except as described
                        in our Notice of Privacy Practices.
                    </p>
                    <br />
                    <p className='mainFont' style={{fontSize: '1em', marginTop: '0'}}><b>Non-Discrimination</b></p>
                    <p className='mainFont' style={{fontSize: '1em', marginTop: '0'}}>
                        No one shall be excluded from or be
                        denied access to services only
                        because of his/her race, color, age,
                        sex, physical or mental handicap,
                        religious creed, national origin, or
                        political beliefs.
                    </p>
        </div>
    )
}
